// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t1jhz","col":"styles_col__19WVH"};